import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { motion } from "framer-motion";
import { styled } from "../styled";
import { useEscapeHatch } from "../escape-hatch";
import { IsElectronContext } from "../contexts";
import { SearchResultKeyboardHint } from "./web/keyboard-hint";
import { WebPortal } from "../web-portals";
import { ZIndexContext } from "../layering";
import { IsInModalCtx } from "./modal";
const ESCHintContainer = styled("div", {
    position: "absolute",
    top: 20,
    left: 20,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 2.5,
    color: "#ddd",
    opacity: 0.5,
});
const ModalRendererChildrenCtx = React.createContext(null);
const ModalRenderer = React.memo(function ModalRenderer(props) {
    const children = React.useContext(ModalRendererChildrenCtx);
    if (children === null) {
        throw new Error("ModalRendererChildrenCtx is null");
    }
    const containerRef = React.useRef(null);
    const onClick = React.useCallback((evt) => {
        if (evt.target === containerRef.current) {
            props.onClose();
        }
    }, [props]);
    const style = React.useMemo(() => ({
        position: "absolute",
        top: props.isElectron ? 40 : 0,
        left: 0,
        height: props.isElectron ? "calc(100% - 40px)" : "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: props.zIndex,
    }), [props.zIndex]);
    return (_jsx(IsInModalCtx.Provider, { value: true, children: _jsxs(motion.div, { ref: containerRef, style: style, initial: {
                backdropFilter: "blur(0px)",
                background: "rgba(0,0,0,0)",
            }, animate: {
                backdropFilter: "blur(8px)",
                background: "rgba(0,0,0,0.5)",
            }, transition: { duration: 300 / 1000 }, onMouseUp: onClick, children: [_jsxs(ESCHintContainer, { children: [_jsx(SearchResultKeyboardHint, { value: "ESC" }), " to close"] }), children] }) }));
});
export const ModalWeb = React.memo(function ModalWeb(props) {
    const isElectron = React.useContext(IsElectronContext);
    const parentModalZIndex = React.useContext(ZIndexContext);
    const zIndex = parentModalZIndex + 10; // We add +5 instead of +1 as context menus use +1
    useEscapeHatch(props.onClose);
    React.useEffect(() => {
        console.log("[ModalWeb] >>> props.children changed");
    }, [props.children]);
    React.useEffect(() => {
        console.log("[ModalWeb] >>> first render");
    }, []);
    console.log("[ModalWeb] >>> zindex", zIndex);
    return (_jsx(ZIndexContext.Provider, { value: zIndex, children: _jsx(ModalRendererChildrenCtx.Provider, { value: props.children, children: _jsx(WebPortal, { children: _jsx(ModalRenderer, { isElectron: isElectron, zIndex: zIndex, onClose: props.onClose }) }) }) }));
});
